'use client';

import { Circle, Flex } from '@chakra-ui/react';

interface SpinnerCircleProps {
  count?: number;
  bg?: string;
}

const SpinnerCircle = ({ count = 8, bg = 'white' }: SpinnerCircleProps) => (
  <Flex
    align='center'
    justify='center'
    h={{
      base: '120px',
      md: '150px'
    }}
    w={{
      base: '120px',
      md: '150px'
    }}
    position='relative'
  >
    {[...Array(count)].map((_, index) => (
      <Circle
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        bg={bg}
        size='20px'
        borderRadius='full'
        position='absolute'
        top='50%'
        left='50%'
        transform={`translate(-50%, -50%) rotate(${
          index * (360 / count)
        }deg) translate(50px) rotate(-${index * (360 / count)}deg)`}
        animation={`hideShow 1.5s infinite ${index * 0.2}s`}
      />
    ))}
    <style jsx global>{`
      @keyframes hideShow {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0.2;
        }
        100% {
          opacity: 1;
        }
      }
    `}</style>
  </Flex>
);

export default SpinnerCircle;
